import { useState } from "react";
import { footerContent } from "@/mocks/homepage";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-dark-900 rounded-t-[2.5rem] mx-3 sm:mx-4 mt-8">
      <div className="w-full px-6 sm:px-8 lg:px-12 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mb-16">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-brand-500 rounded-lg">
                  <i className="ri-shield-check-line text-white text-lg"></i>
                </span>
                <span className="font-bold text-xl text-white">
                  {footerContent.company}
                </span>
              </div>
              <p className="text-dark-300 text-sm leading-relaxed mb-6 max-w-sm">
                {footerContent.tagline} Profesionalna bezbednosna rešenja za dom i biznis — IP kamere, video interfoni, kontrola pristupa i alarmni sistemi.
              </p>

              <h4 className="font-bold text-white mb-3 text-sm uppercase tracking-wider">
                Newsletter
              </h4>
              <p className="text-dark-400 text-xs mb-4">
                Dobijajte stručne savete o bezbednosti direktno na email.
              </p>
              {subscribed ? (
                <p className="text-brand-400 text-sm font-medium flex items-center gap-2">
                  <i className="ri-check-line"></i>
                  Uspešno ste se prijavili!
                </p>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    fetch("https://readdy.ai/api/form/d8h9irscl43d0bibeid0", {
                      method: "POST",
                      headers: { "Content-Type": "application/x-www-form-urlencoded" },
                      body: new URLSearchParams({ email }).toString(),
                    })
                      .then(() => { setSubscribed(true); setEmail(""); })
                      .catch(() => { setSubscribed(true); });
                  }}
                  className="flex gap-2 max-w-sm"
                  data-readdy-form=""
                >
                  <input
                    type="email"
                    name="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Vaša email adresa"
                    className="flex-1 px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder:text-dark-400 focus:outline-none focus:border-brand-400 transition-all"
                  />
                  <button
                    type="submit"
                    className="bg-brand-500 hover:bg-brand-600 text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    Prijavi se
                  </button>
                </form>
              )}
            </div>

            <div>
              <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">
                Proizvodi
              </h4>
              <ul className="space-y-3">
                {footerContent.links.product.map((link, index) => (
                  <li key={index}>
                    <Link
                      to="/products"
                      className="text-dark-300 hover:text-white text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">
                Kompanija
              </h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection("about")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    O nama
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("projects")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Projekti
                  </button>
                </li>
                <li>
                  <Link
                    to="/blog"
                    className="text-dark-300 hover:text-white text-sm transition-colors"
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Karijera
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-white mb-5 text-sm uppercase tracking-wider">
                Podrška
              </h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Kontakt
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("faq")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Tehnička podrška
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("guarantee")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Garancija
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="text-dark-300 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    Dostava
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-dark-400 text-xs">
              {footerContent.copyright}
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 text-dark-300 hover:bg-brand-500 hover:text-white transition-all">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 text-dark-300 hover:bg-brand-500 hover:text-white transition-all">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 text-dark-300 hover:bg-brand-500 hover:text-white transition-all">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 text-dark-300 hover:bg-brand-500 hover:text-white transition-all">
                <i className="ri-linkedin-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-hidden pb-8">
        <div className="text-[15vw] font-black text-white/[0.03] leading-none select-none whitespace-nowrap">
          {footerContent.company.toUpperCase()}
        </div>
      </div>
    </footer>
  );
}